/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";

export function InitializeFindFormPage() {
      CreateTHEADSectionGV("gvForms1");

      $('.responsiveTable').DataTable({
         "responsive": true,
         "scrollX": false,
         "paging": false,
         "searching": false,
         "ordering": false,
         "info": false
      });

       $(".gridView-item").attr("tabindex", "-1");

      $("#divGFBDisclaimer, #divSCHDialog").dialog({
         modal: true,
         autoOpen: false,
         title: "Informational Message:",
         width: 560,
         buttons: [
            {
               id: "btnOK",
               text: "OK",
               click: function () {
                  var href = $(this).dialog("option", "href");
                  var target = $(this).dialog("option", "target")
                  if (target == "thisWindow") {
                     window.location.href = href
                  } else {
                     window.open(href);
                  }
                  $(this).dialog('close');
               }
            },
            {
               id: "btnCancel",
               text: "Cancel",
               click: function () {
                  $(this).dialog('close');
               }
            }
         ]
      });

      // ********************* GFB **************************
      $(".esignGFB").click(function (e) {
         // display the appropriate text
         $('#pGFBEsign').css("display", "block");
         $('#pGFBEnglishDownload').css("display", "none");
         $('#pGFBSpanishDownload').css("display", "none");
         // set the destination and open the dialog box.
         $('#divGFBDisclaimer').dialog("option", "href", "/DL/secure/borrower/formwizard/gfb/gfbstatus.aspx")
         $('#divGFBDisclaimer').dialog("option", "target", "thisWindow");
         $('#divGFBDisclaimer').dialog('open');
      });

      $(".downloadGFBEnglish").click(function (e) {
         // display the appropriate text
         $('#pGFBEsign').css("display", "none");
         $('#pGFBEnglishDownload').css("display", "block");
         $('#pGFBSpanishDownload').css("display", "none");
         // set the destination and open the dialog box.
         $('#divGFBDisclaimer').dialog("option", "href", "viewForm.aspx?DocID=142&Language=English");
         $('#divGFBDisclaimer').dialog('open');
      });

      $(".downloadGFBSpanish").click(function (e) {
         // display the appropriate text
         $('#pGFBEsign').css("display", "none");
         $('#pGFBEnglishDownload').css("display", "none");
         $('#pGFBSpanishDownload').css("display", "block");
         // set the destination and open the dialog box.
         $('#divGFBDisclaimer').dialog("option", "href", "viewForm.aspx?DocID=142&Language=Spanish");
         $('#divGFBDisclaimer').dialog('open');
      });

      // *********************** SCH *******************
      $(".downloadSCH").click(function (e) {
         // display the appropriate text
         $('#divSCHDialog').css("display", "block");
         // set the destination and open the dialog box.
         $('#divSCHDialog').dialog("option", "href", "viewForm.aspx?DocID=122&Language=English");
         $('#divSCHDialog').dialog('open');
      });

      $(".downloadSpanishSCH").click(function (e) {
         // display the appropriate text
         $('#divSCHDialog').css("display", "block");
         // set the destination and open the dialog box.
         $('#divSCHDialog').dialog("option", "href", "viewForm.aspx?DocID=122&Language=Spanish");
         $('#divSCHDialog').dialog('open');
      });
}
